import Cargo from '@quick/assets/icons/lines/cargo.svg';
import carry from '@quick/assets/icons/lines/carry.svg';
import delivery from '@quick/assets/icons/lines/delivery.svg';
import Distribution from '@quick/assets/icons/lines/distribution.svg';
import FLTruck from '@quick/assets/icons/lines/FLTruck.svg';
import FLTruckPentagon from '@quick/assets/icons/lines/FLTruckPentagon.svg';
import Global from '@quick/assets/icons/lines/global.svg';
import Go from '@quick/assets/icons/lines/go.svg';
import moto from '@quick/assets/icons/lines/moto.svg';
import TruckFlorida from '@quick/assets/icons/lines/TruckFlorida.svg';
import USTruck from '@quick/assets/icons/lines/USTruck.svg';
import USTruckPentagon from '@quick/assets/icons/lines/USTruckPentagon.svg';
import Warehouse from '@quick/assets/icons/lines/Warehouse.svg';

const lineIcons = {
  global: Global,
  distribution: Distribution,
  lastMille: Go,
  cargo: Cargo,
  delivery,
  carry,
  moto,
  FLTruck,
  FLTruckPentagon,
  USTruck,
  USTruckPentagon,
  TruckFlorida,
  Warehouse,
} as const;

export const lineIconsNames = Object.keys(
  lineIcons
) as (keyof typeof lineIcons)[];
export { lineIcons };
